export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_COUNTRY = 'gb';
